import request from "./../utils/request";
import { getPersistenceData } from "../utils/persistenceStorage";

const visitorId = () => {
    try {
        return getPersistenceData("visitorId") || null;
    } catch (e) {
        return null;
    }
};

export const getHelpCenter = () => request.get("/helpcenter");
export const getCollection = (id) => request.get(`/helpcenter/collections/${id}`);
export const getArticle = (idOrSlug, lang) => request.get(`/helpcenter/articles/${encodeURIComponent(String(idOrSlug))}`, { params: { lang } });
export const searchHelpCenter = (q, lang) => request.get("/helpcenter/search", { params: { q, lang, visitorId: visitorId() } });
export const viewArticle = (id, locale) => request.post(`/helpcenter/articles/${id}/view`, { visitorId: visitorId(), locale });
export const reactArticle = (id, reaction, locale) => request.post(`/helpcenter/articles/${id}/reaction`, { reaction, visitorId: visitorId(), locale });
export const startChatFromArticle = (id, locale) => request.post(`/helpcenter/articles/${id}/start-chat`, { visitorId: visitorId(), locale });
export const getArticlesByIds = (ids) => request.get("/helpcenter/articles", { params: { ids: (ids || []).join(",") } });
export const getPopularArticles = (limit = 5) => request.get("/helpcenter/popular", { params: { limit } });



// WEBPACK FOOTER //
// ./src/api/helpcenter.js